import { render, staticRenderFns } from "./crown.vue?vue&type=template&id=020ca625&"
import script from "./crown.vue?vue&type=script&lang=js&"
export * from "./crown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports